import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function PublicInvestmentProjectDetails({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="f07fb49d-92c2-4727-99f8-f8b415c7191e"
              height="30px"
              showLoader={false}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">

              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* straight table */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="4b2c0b97-37df-4508-a650-bebb0295e4f5"
                        height="max(calc(100vh - 233px), 300px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        onBeforeExportHandler={async ({  }) => {
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                        exportNoObjectText={menuItemsStrings.exportNoObjectText}
                        actionsVisibility="always"
                      />
                    </div>
                  </div>

                </div>

              </div>

            </div>


            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  {/* FilterPane */}
                  <QlikCard
                    id="KePu"
                    //height="max(calc((100vh - 233px)/2 - min(calc(10.5vh + 2px), 64px) - 12px), calc(160px - min(calc(10.5vh + 2px), 64px) - 12px)"
                    height="calc((100vh - 233px)*0.6 - 12px"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  <QlikObject
                    id="BUymc"
                    height="min(calc(10.5vh + 2px), 64px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  {/* Columns Selector */}
                  <QlikCard
                    id="eqmNRK"
                    //height="max(calc(100vh - 233px)/2, 100px)"
                    height="calc((100vh - 233px)*0.4 - min(calc(10.5vh + 2px), 64px))"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div>

          </div>

          <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="sZmBgv"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>
          
        </div>
    </section>
  );
}
